import MediaItem from './mediaItem'
import Entity from './entity'
export default class Podcast extends Entity<number> {
    title:string;
    shortDescription:string;
    tenantId:number;
    imageUrl:string;
    imageId:number;
    podcastsMediaItems: Array<MediaItem>;
    podcastId:number;
    mediaItemToDeleteId:number;

    constructor() {
        super();
        this.imageUrl= "";
        this.imageId=0;
        this.podcastsMediaItems =[];
  	}
}